import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { AZURE_CA_URLS } from '../../../app/shared/enums/HttpStatusCodes';
import { environment } from '../../../environments/environment';
import { AUTENTIFICACION_ENDPOINTS, GESTION_USUARIOS_ENDPOINTS } from '../../shared/models/Constants';
import { SharedServiceService } from '../../shared/services/shared-service.service';
import {
    errorGetProfile,
    errorUpdateProfile,
    errorValidCurrentPass,
    errorValidNewPhone,
    getProfile,
    successGetProfile,
    successUpdateProfile,
    successValidCurrentPass,
    successValidNewPhone,
    updateProfile,
    validCurrentPass,
    validNewPhone,
} from '../actions/profile.actions';

@Injectable()
export class ProfileEffects {
    constructor(
        private actions$: Actions
        , private httpS: SharedServiceService
    ) { }

    /*
     * Consulta los datos de perfil y configuracion para el modulo
     */
    public getProfile$ = createEffect(
        () => this.actions$.pipe(
            ofType(getProfile),
            map((actions) => ({ ...actions, Version: environment.versionNumber })),
            switchMap((actions) =>
                this.httpS.executeRequestByUser(GESTION_USUARIOS_ENDPOINTS.post_get_user_profile, actions, this.httpS.getAzureCAUrl(AZURE_CA_URLS.USUARIOS))
                    .pipe(
                        map(resp => successGetProfile(resp)),
                        catchError((err: Error) => of(errorGetProfile({ payload: err })))
                    )
            )
        )
    );

    /*
     * Actualiza datos del perfil
     */
    public updateProfile$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateProfile),
            switchMap((actions) =>
                this.httpS.executeRequestByUser(AUTENTIFICACION_ENDPOINTS.put_update_profile, actions.params)
                    .pipe(
                        map(resp => successUpdateProfile(resp)),
                        catchError((err: Error) => of(errorUpdateProfile({ payload: err })))
                    )
            )
        )
    );

    /*
     * Valida la contraseña actual
     */
    public validCurrentPass$ = createEffect(
        () => this.actions$.pipe(
            ofType(validCurrentPass),
            switchMap((actions) =>
                this.httpS.executeRequestByUser(GESTION_USUARIOS_ENDPOINTS.validate_current_password, actions, this.httpS.getAzureCAUrl(AZURE_CA_URLS.USUARIOS))
                    .pipe(
                        map(resp => successValidCurrentPass(resp)),
                        catchError((err: Error) => of(errorValidCurrentPass({ payload: err })))
                    )
            )
        )
    );

    /*
     * Valida nuevo teléfono
     */
    public validNewPhone$ = createEffect(
        () => this.actions$.pipe(
            ofType(validNewPhone),
            switchMap((actions) =>
                this.httpS.executeRequestByUser(GESTION_USUARIOS_ENDPOINTS.authenticates_phone_retailer, actions, this.httpS.getAzureCAUrl(AZURE_CA_URLS.USUARIOS))
                    .pipe(
                        map((resp: Array<{ code: number, message: string }>) => successValidNewPhone(resp[0])),
                        catchError((err: Error) => of(errorValidNewPhone({ payload: err })))
                    )
            )
        )
    );
}
